import { render, staticRenderFns } from "./online_aftersale_detail.vue?vue&type=template&id=4fb3336e&scoped=true"
import script from "./online_aftersale_detail.vue?vue&type=script&lang=js"
export * from "./online_aftersale_detail.vue?vue&type=script&lang=js"
import style0 from "./online_aftersale_detail.vue?vue&type=style&index=0&id=4fb3336e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3336e",
  null
  
)

export default component.exports